import {createSlice} from '@reduxjs/toolkit';
import {promisePostSimple} from "./fetch";
import {SignLib} from "../utils/ndipitsign";

import {setErrorInformation, toggleLoader} from "./application";
import {CA_SERVERS_ENDPOINT} from '../constants/app-constants';
import {logger} from "../utils/logger";

const initialState = {
  caServers: [],
  caServer: {},
  privateKeyFile: null,
  privateKeyPassword: null,
  certData: null
};

export const signSlice = createSlice({
  name: 'sign',
  initialState,
  reducers: {
    setCAServers: (state, {payload}) => {
      let caServersDictionary = [];
      payload.forEach((val, idx) => {
        caServersDictionary.push(Object.assign({}, val, {
          name: val.issuerCNs[0], // БТ9220#c37714 согласовано
          id: idx
        }))
      });
      state.caServers = caServersDictionary;
    },
    setCAServer: (state, {payload}) => {
      state.caServer = payload;
    },
    setPrivateKeyFile: (state, action) => {
      return {...state,
        privateKeyFile: action.payload
       }
    },
    setPrivateKeyPassword: (state, {payload}) => {
      state.privateKeyPassword = payload;
    },
    setCertData: (state, {payload}) => {
      state.certData = payload;
    },
    clearSignParams: state => {
      return {...initialState};
    }
  }
});

export const signSelector = state => state.sign;

export const {setCAServers, setCAServer, setPrivateKeyFile, setPrivateKeyPassword, setCertData, clearSignParams} = signSlice.actions;

export const loadCAServers = () => {
  return async (dispatch, getState) => {
    try {
      let {caServer} = signSelector(getState());
      const caServers = await dispatch(promisePostSimple(CA_SERVERS_ENDPOINT));
      dispatch(setCAServers(caServers));

      if (!caServer) {
        const cid = SignLib.getLastCAServerId();//side-effect - from localstorage
        if (cid && cid < caServers.length) {
          caServer = caServers[cid];
        }
      }
      dispatch(setCAServer(caServer));
      SignLib.setCAServersList(caServers, caServer);
    }
    catch (reason) {
      logger.errorLog("Failed to get CA servers!", reason);
      dispatch(setErrorInformation('Не вдалося отримати список серверів ЦСК.'));
    }
  }
};

const prepareKeyWithChecks = () => {
  return async (dispatch, getState) => {
    let signParams = signSelector(getState());

    try {
      //decode key and get cert
      const { rawCert, certInfo } = await SignLib.prepareKey(signParams);
      const certData = {
        certificateSerial: certInfo.GetSerial(),
        certificateIssuer: certInfo.GetIssuer(),
        inn: certInfo.GetSubjDRFOCode(),
        edrpou: certInfo.GetSubjEDRPOUCode(),
        // до подписания rawCert передаём на сервер в prepareSignDB целиком и там распрасим
        // согласно І.Аулову получать его на беке с ЦСК по issuer+serial неправильно,
        // т.к. только некоторые ЦСК поддерживают получение сертификата с сервера (видимо, по CMP)
        // (общение в скайпе 06.08.2019 по багу 6554)
        rawCert: SignLib.base64Encode(rawCert)
      };

      if (!certData.inn)
        throw {message: "В сертифікаті відсутня інформація про РНОКПП власника"};

      /*signParams = {
        ...signParams,
        ...certData
      };*/

      dispatch(setCertData(certData));

      /*let isSealRequired = signParams.isSealRequired;
      if (typeof isSealRequired === 'undefined')
        isSealRequired = await dispatch(getSignTypeIsSeal(signStoreConfig, signParams.signTypeId));

      await checkSelectedCertType(isSealRequired, certInfo);

      if (signParams.isNeedPrepareSign) {
        await dispatch(prepareSignDB(certData));
      }*/
      return true;
    }
    catch (errorInfo) {
      logger.errorLog('loadCertInfo exception!', errorInfo);
      dispatch(onSignProcessError({
        message: 'Помилка читання ключової інформації!',
        errorData: typeof (errorInfo) === 'string' ? errorInfo :`${errorInfo.message}${errorInfo.data ? ' ' + errorInfo.errorData : ''}`
      }));
      return false;
    }
  }
};

const onSignProcessFinished = (isSuccess, addSignResult) => {
  return (dispatch, getState) => {
    const signParams = signSelector(getState());
      //action = signParams.action;

    dispatch(toggleLoader(false));


    /*if (signParams.isCloseModalDlgAfterSign && isSuccess)
      dispatch(openSignView(false));
    if (isSuccess)
      dispatch(setNewData({}, signStoreConfig.storeId));

    if (isSuccess && action) action(addSignResult, signParams);*/
  }
};


export const onSignProcessError = (errorInfo) => {
  return (dispatch, getState) => {
    //const isErrorHandled = getState().showError;
    //if (!isErrorHandled) {
      let errorMsgFull = "Помилки при накладенні підпису!";
      if (errorInfo) {
        if (errorInfo.message)
          errorMsgFull = errorInfo.message;
        else if (typeof errorInfo === 'string')
          errorMsgFull = errorInfo;
        if (errorInfo.errorData) {
          errorMsgFull += ' ';
          if (typeof errorInfo.errorData.message === 'string')
            errorMsgFull += errorInfo.errorData.message;
          else if (typeof errorInfo.errorData === 'string')
            errorMsgFull += errorInfo.errorData;
          else if (errorInfo.errorData.resultMessage)
            errorMsgFull += errorInfo.errorData.resultMessage;
        }
      }
      dispatch(setErrorInformation(errorMsgFull));
    //}
    dispatch(onSignProcessFinished(false));
  }
}


//застосування параметрів підписування при натисненні 'Ok' на формі вибору параметрів
export const applyUserSignParams = () => {
  return async (dispatch, getState) => {
    const signParams = signSelector(getState());

    let errText = '';

    if (!signParams.caServer) {
      errText = "Не вказано сервер ЦСК.";
    } else if (!signParams.privateKeyFile && !signParams.isUseSW) {
      errText = "Не вказано файл ключа.";
    } else if (!signParams.mediaTypeId && signParams.mediaTypeId !== 0 && signParams.isUseSW) {
      errText = "Не обраний тип носія ключової інформації";
    } else if (!signParams.mediaDeviceId && signParams.mediaDeviceId !== 0 && signParams.isUseSW) {
      errText = "Не обраний носій ключової інформації";
    } else if (!signParams.privateKeyPassword) {
      errText = "Не вказано пароль до файла ключа.";
    };

    if (errText) {
      dispatch(onSignProcessError({ message: errText }));
      return false;
    }
    dispatch(toggleLoader(true));
    try {
      const isPrepared = await dispatch(prepareKeyWithChecks());
      dispatch(onSignProcessFinished(isPrepared));
      return isPrepared;
      /*if (!isPrepared) return;

      if (signParams.isLoginSign)
        dispatch(doLoginSignature());
      else
        dispatch(getSignStrings());*/
    }
    catch (errorInfo) {
      logger.errorLog('Sign applying process failed!', errorInfo);
      dispatch(onSignProcessError(errorInfo));
    }
  }
};


export default signSlice.reducer;